/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PGATourLoadSavedModelFilterInput = {|
  pgaTourModelId: string,
  savedModelFilterId: string,
  clientMutationId?: ?string,
|};
export type PGAModelBuilderPageLoadInputMutationVariables = {|
  input: PGATourLoadSavedModelFilterInput
|};
export type PGAModelBuilderPageLoadInputMutationResponse = {|
  +pgaTourLoadSavedModelFilter: ?{|
    +success: ?boolean
  |}
|};
export type PGAModelBuilderPageLoadInputMutation = {|
  variables: PGAModelBuilderPageLoadInputMutationVariables,
  response: PGAModelBuilderPageLoadInputMutationResponse,
|};
*/


/*
mutation PGAModelBuilderPageLoadInputMutation(
  $input: PGATourLoadSavedModelFilterInput!
) {
  pgaTourLoadSavedModelFilter(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PGATourLoadSavedModelFilterPayload",
    "kind": "LinkedField",
    "name": "pgaTourLoadSavedModelFilter",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PGAModelBuilderPageLoadInputMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PGAModelBuilderPageLoadInputMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "01b0528070ad81e99943e8e1c3145b09",
    "id": null,
    "metadata": {},
    "name": "PGAModelBuilderPageLoadInputMutation",
    "operationKind": "mutation",
    "text": "mutation PGAModelBuilderPageLoadInputMutation(\n  $input: PGATourLoadSavedModelFilterInput!\n) {\n  pgaTourLoadSavedModelFilter(input: $input) {\n    success\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0f8358fac4753fd18ef795291249155e';

module.exports = node;
